var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalContentContainer',{attrs:{"modalTitle":"Alterar frete"}},[_c('FreightContent'),_c('MainButton',{staticClass:"main-button",attrs:{"isDisabled":!_vm.selectedFreight},nativeOn:{"click":function($event){return _vm.closeModal.apply(null, arguments)}}},[_c('span',[_vm._v("Fechar")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }